import { save, openWhatsapp, getMeta, isDesktop, getMessage } from '../store.js';

(($) => {

    async function handleFormSubmission(e, response) {

        /* The `// Submitted Fields` section in the code is iterating over the fields received in the
        form submission response and extracting key-value pairs for each field. It filters out the
        'submit' field and creates an object `fields` containing the key-value pairs of the
        submitted form fields. */
        // console.log('response', response);
        const formId = response.id || 0


        // Submitted Fields.
        const fields = {}
        Object.values(response.response.data.fields).forEach( field => {
            if ( 'submit' !== field.key ) {
                fields[ field.key ] = field.value
            }
        })


        const widget = document.querySelector('[data-whatsapp]');

        if (widget ) {

            // Inside widget.
            const widgetId = widget.dataset.widget;
            if (!widgetId) return;
 
            const widgetObject = formychat_vars.data.widgets.find(widget => widget.id == widgetId);
            if ( !widgetObject ) return;

            // Notify parent.
            window.parent.postMessage({ formychat_submitted: true }, '*');

            const whatsappNumber = widget.dataset.whatsapp;
            
            const { new_tab, web_version, ninja_message_template } = widgetObject.config.whatsapp || {};
            const message = getMessage(ninja_message_template || form.ninja_message_template || '', fields);
            const data = {
                form: 'ninja',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
            }
            
            save(data, whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsappNumber, message, isDesktop() && web_version == 1, new_tab == 1);

        } else {
            
            const settings = response.response.data.actions.formychat || null;

            if ( !settings ) return;
            

            const { whatsapp_number, message, new_tab, web_version } = settings;
            const formattedMessage = getMessage(message, fields);

            const data = {
                form: 'ninja',
                form_id: formId,
                field: fields,
                meta: getMeta.value,
            }

            save(data, whatsapp_number, formattedMessage, isDesktop() && web_version == 1, new_tab == 1);
            openWhatsapp(whatsapp_number, formattedMessage, isDesktop() && web_version == 1, new_tab == 1);
        }
    }

    $(document).on('nfFormSubmitResponse', handleFormSubmission)

})(jQuery)
